module.exports = __webpack_public_path__ + "img/informe_pei.5dec7724.svg";